import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import SettingsSidebar from '../components/SettingsSidebar'

import { Button, ImageUploadController, PageLayout } from 'Components'
import { constants } from 'Config'
import { useAppDispatch, useAppSelector } from 'ReduxStore/hooks'
import { keyCloakUserSelector, updateKeycloakProfileAction } from 'ReduxStore/keyCloakUser'
import { useImageUploading } from 'Utils/helpers/useImageUploading'

const ProfilePictureSettingsPage: React.FC = () => {
  const dispatch = useAppDispatch()
  const user = useAppSelector(keyCloakUserSelector)
  const { isImageUploading, setTempImageId, setIsImageUploading, onImageSubmit, onPageExit } = useImageUploading({
    imageUrl: user.attributes.imageUrl
  })

  useEffect(() => {
    return () => {
      onPageExit()
    }
  }, [])

  const {
    register,
    control,
    errors,
    handleSubmit,
    setValue,
    setError,
    formState: { isSubmitting }
  } = useForm<{ imageUrl: string }>({
    defaultValues: { imageUrl: user.attributes.imageUrl }
  })

  const onSubmit = handleSubmit((values): void => {
    const legacyImageUrlUploadPayload = {
      ...user,
      attributes: { ...user.attributes, imageUrl: values.imageUrl }
    }

    dispatch(updateKeycloakProfileAction(user.id, legacyImageUrlUploadPayload, { withDefaultSuccessToast: true })) //@ts-ignore
      .then(async () => {
        await onImageSubmit(values.imageUrl)
      })
  })

  return (
    <PageLayout variant="smallcircle">
      <div className="container max-900">
        <div className="row">
          <SettingsSidebar />

          <div className="col-12 col-lg-8">
            <h1>Einstellungen</h1>

            <h2 className="mb-3 mt-4">Mein Profilbild</h2>

            <div className="basiccard p-3">
              <form onSubmit={onSubmit} noValidate>
                <div className="mb-5">
                  <ImageUploadController
                    name="imageUrl"
                    path={constants.imageServiceFolders.userPictures}
                    theme="circle"
                    onIdChange={setTempImageId}
                    onUploadingChange={setIsImageUploading}
                    setError={setError}
                    register={register}
                    setValue={setValue}
                    errors={errors}
                    control={control}
                  />
                </div>
                <div className="row col-md-6 offset-md-3">
                  <Button type="submit" disabled={isSubmitting || isImageUploading}>
                    Speichern
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  )
}

export default ProfilePictureSettingsPage
